import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

import Global from '../../store/global-selectors';
import { UserPermissionService } from '../../services/user-permission-service';
import { useShowProgressiveDisclosure } from '../../feature-flags/hooks/use-show-progressive-disclosure';
import { SETUP_PATH } from '../../routes/constants';

export const CompleteSetupRequired = ({ children }) => {
  const userRoles = useSelector(Global.selectUseruserRoles);
  const isSysAdmin = UserPermissionService.userIsSystemAdministrator(userRoles);
  const shouldShowProgressiveDisclosure = useShowProgressiveDisclosure();
  return shouldShowProgressiveDisclosure && !isSysAdmin ? <Redirect to={SETUP_PATH} /> : children;
};

CompleteSetupRequired.propTypes = {
  children: PropTypes.node.isRequired,
};
